// extracted by mini-css-extract-plugin
export var cornerPolygon = "styles-module--corner-polygon--7347d";
export var message = "styles-module--message--92df3";
export var messageWrapper = "styles-module--message-wrapper--28e76";
export var messagesWrapper = "styles-module--messages-wrapper--07935";
export var title = "styles-module--title--45193";